import axios from 'axios';



// ایجاد instance اصلی axios
const api = axios.create({
  baseURL: 'https://api2.narvansabz.ir/api',
  //baseURL: 'http://localhost:6060/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor برای اضافه کردن توکن به header
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor برای مدیریت خطاها
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('API Error:', error);
    
    // اگر توکن منقضی شده باشد
    if (error.response?.status === 401) {
      console.log('🔍 API - 401 error detected, but not redirecting automatically');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // حذف redirect خودکار - اجازه دهید component تصمیم بگیرد
      // window.location.href = '/#/auth/signin';
    }
    
    // اگر خطای CORS باشد
    if (error.message === 'Network Error' || error.code === 'ERR_NETWORK') {
      console.error('CORS Error - بررسی کنید که سرور در حال اجرا باشد');
    }
    
    return Promise.reject(error);
  }
);

export default api; 